import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import React, { useContext, useRef, useState } from "react";

import useText from "../../hooks/use-text";
import { FilesContext } from "../../providers/files-provider";
import { LocalizedStrings, SupportedLanguages } from "../../utils/lang";

type Props = {
  label: string;
};

export default function Search(props: Props): React.ReactElement {
  const { label } = props;
  const { filter, setFilter } = useContext(FilesContext);
  const [canClear, setCanClear] = useState<boolean>(false);
  const { strings } = useText(local);

  const ref = useRef<HTMLInputElement>();
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // ToDo: Maybe add a throttling to it to reduce the query-request on each keypress

    const value = event.target.value;
    setFilter({
      ...filter,
      name: {
        icontains: `%${value}%`,
      },
    });
    if (!!value || !canClear) {
      setCanClear(true);
    } else if (!value || canClear) {
      setCanClear(false);
    }
  };

  function handleClear(): void {
    if (!canClear) {
      return;
    }

    if (ref.current) {
      ref.current.value = "";
    }
    setCanClear(false);
    setFilter({
      ...filter,
      name: undefined,
    });
  }

  return (
    <div className="relative w-full">
      <label className="absolute text-[12px] top-[7px] left-[15px] text-slate-500 z-10">
        {label}
      </label>
      <TextField
        inputRef={ref}
        className="shadow border-0 rounded-[15px] bg-white w-full"
        placeholder={strings.placeholder}
        onChange={handleSearch}
        sx={{
          "& .MuiInputBase-input": { paddingTop: "24px", paddingBottom: "9px" },
          ".MuiOutlinedInput-notchedOutline": {
            border: 0,
            borderRadius: "15px",
          },
        }}
        InputProps={{
          onClick: handleClear,
          endAdornment: !canClear ? (
            <SearchIcon className="text-[22px] text-slate-400" />
          ) : (
            <ClearIcon className="text-[22px] text-slate-400 cursor-pointer" />
          ),
        }}
      />
    </div>
  );
}

type LocalSchema = {
  placeholder: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    placeholder: "Enter keyword",
  },
};
